import React from "react";
import { useUnit } from "effector-react";
import Button from "@/core/components/button/Button";
import "./Upgrade.scss";
import { SvgIcon } from "@/core/components/svgIcon/SvgIcon";
import { $userBasicInfo, $userPlan } from "@/features/user/store";
import {
  PlanType,
  SubscriptionResponse,
} from "@/features/settings/service/userService";
import { Link } from "react-router-dom";

export const Upgrade = () => {
  const [userPlan] = useUnit([$userPlan]);
  const [userBasicInfo] = useUnit([$userBasicInfo]);
  const { pro_user, is_new, partner, plan, free_trial } = userBasicInfo || {};

  const getPlan = (
    plan: boolean | PlanType | SubscriptionResponse | undefined,
  ) => {
    if (plan === false || plan === undefined) {
      return "Starter Plan";
    }
    if (typeof plan === "object") {
      // Handle new subscription format
      if ("subscription" in plan) {
        return `${plan?.subscription?.plan}, ${plan.subscription?.status}`;
      }
      // Handle legacy PlanType format
      if ("plan_name" in plan && "plan_status" in plan) {
        return `${plan.plan_name}, ${plan.plan_status}`;
      }
    }
    return "Starter Plan";
  };

  return (
    <div className="upgrade-component">
      <div className="upgrade-status">
        <SvgIcon
          icon={`${
            getPlan(plan) === "Starter Plan" ? "icon-starter" : "icon-thunder"
          }`}
        />
        <span className="upgrade-plan">{getPlan(plan)}</span>
      </div>
      {getPlan(plan) === "Starter Plan" && free_trial === true ? (
        <Link to={"/settings/subscription"} className="start-button">
          Start your 14-day free trial
        </Link>
      ) : (
        <Link to={`/settings/subscription`} className="manage-button">
          Manage subscription
        </Link>
      )}
    </div>
  );
};
